import React, { ReactElement } from "react";

interface CommentActionButtonProps {
  onClick: () => void;
  icon: ({ className }: { className: string }) => ReactElement;
  label: string;
}

export const CommentActionButton: React.FC<CommentActionButtonProps> = (
  props,
) => {
  const { onClick, label } = props;

  return (
    <div className="flex items-center touchable" onClick={onClick}>
      <props.icon className="w-3 h-3 text-gray-400" />
      &nbsp;
      <span className="text-sm text-gray-400">{label}</span>
    </div>
  );
};
